<template>
  <!--
      作者：luoyiming
      时间：2020-06-01
      描述：插件中心-文章-添加
    -->
  <div class="product-add pb50">
   <!--添加文章-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">编辑</div>
      <el-form-item label="标题" prop="course_name"><el-input v-model="form.course_name" placeholder="请输入标题" class="max-w460"></el-input></el-form-item>


      <el-form-item label="选择章节" >
        <el-input type="text"  autocomplete="off" class="max-w460">
        <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openChapterDialog">选择章节</el-button>
        </el-input>
      </el-form-item>
      <el-table :data="chapterList" size="small" border style="width: 800px;margin: 30px;" v-loading="loading">
        <el-table-column prop="chapter_id" label="章节ID" width="70px"></el-table-column>
        <el-table-column prop="chapter_name" label="章节标题"></el-table-column>

    <!--    <el-table-column prop="is_free" label="是否免费" width="120">
          <template slot-scope="scope">
          <el-radio-group v-model="scope.row.is_free">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>

           </template>
        </el-table-column> -->
        <!-- <el-table-column prop="price" label="价格" width="120">

          <template slot-scope="scope">
            <el-input v-model="scope.row.price" v-if="scope.row.is_free?'readonly':''" placeholder="请输入价格" ></el-input>
          </template>
        </el-table-column> -->
        <el-table-column prop="sort" label="排序" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.sort" placeholder="请输入排序" ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" width="90">
          <template slot-scope="scope">
            <el-button @click="deleteChapter(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>


      <!-- <el-form-item label="描述" prop="course_content"><el-input v-model="form.course_content" placeholder="请输入文章描述" type="textarea" class="max-w460"></el-input></el-form-item> -->
      <!--内容-->
      <el-form-item label="课程介绍">
        <div class="d-s-c">

          <div class="edit_container">
            <Uediter v-if="ueditor.text" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
          </div>

        </div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--章节选择-->
    <Chapter :is_open="open_chapter" :excludeIds='chapter_id' :islist='true' @close="closeChapterDialog"></Chapter>
  </div>
</template>

<script>
import CourseApi from '@/api/course.js';
import Chapter from '@/components/course/Chapter.vue';
import Uediter from '@/components/UE.vue';
export default {
  components: {
    Chapter,
    /*编辑器*/
    Uediter
  },
  data() {
    return {
      open_chapter:false,

      /*form表单数据*/
      form: {
        course_name: '',
        course_content: '',
      },
      chapter_id:[],
      chapterList:[],
      loading: false,
      /*验证规则*/
      rules: {
        course_name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        course_content: [{ required: true, message: '请输入描述', trigger: 'blur' }],

      },

      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },

    };
  },
  created() {
    let course_id = this.$route.query.course_id;
    this.getData(course_id);
  },
  methods: {
    /*打开章节弹窗*/
    openChapterDialog() {
      this.open_chapter = true;
    },
    /*关闭题目列表弹窗*/
    closeChapterDialog(e) {
      if (e.type != 'error') {
        let chapter_id = [];
        let chapter_ids = [];
        this.chapterList.forEach((item,index)=>{
          chapter_id.push(parseInt(item.chapter_id))
          chapter_ids.push(parseInt(item.chapter_id))
        })

        e.params.forEach((item,index)=>{
          let result = chapter_id.includes(item.chapter_id);

          if(!result){
            this.chapterList.push({'chapter_id':item.chapter_id,'chapter_name':item.chapter_name.substr(0,50),'price':0,'is_free':0,'sort':(this.chapterList.length+1)})
            chapter_ids.push(item.chapter_id);
            this.chapter_id = chapter_ids;
          }

        })

      }
      this.open_chapter = e.openDialog;
    },
    /*删除章节*/
    deleteChapter(index) {

      var self = this;
      let chapter = [];
      let chapter_id = [];
      let key = 1;
      self.chapterList.forEach(function(value) {

        if(index.chapter_id != value.chapter_id){
          value.sort = key;
          chapter.push(value)
          chapter_id.push(value.chapter_id)
          key++
        }
      });
      self.chapterList = chapter
      self.chapter_id = chapter_id
    },
    getData(course_id) {
      let self = this;
      CourseApi.courseDetail(
        {
          course_id: course_id
        },
        true
      )
        .then(data => {
          self.ueditor.text = data.data.detail.course_content;
          console.log(self.ueditor.text);
          self.form=data.data.detail;

          if(!data.data.detail.chapter){
            self.chapterList = [];
            self.chapter_id = [];
          }else{
            self.chapterList = data.data.detail.chapter;
            data.data.detail.chapter.forEach(item=>{
              self.chapter_id.push(item.chapter_id)
            })
          }
          self.loading=false;
          self.isImg =true;
        })
        .catch(error => {
          self.loading=false;
        });
    },

    /*编辑课程*/
    onSubmit() {
      let self = this;
      let form = self.form;
      if(!form.course_name){
        self.$message({
          message: '标题不能为空',
          type: 'error'
        });
        return false;
      }
      if(self.chapterList.length <1){
        self.$message({
          message: '章节不能为空',
          type: 'error'
        });
        return false;
      }

      form.course_content = this.$refs.ue.getUEContent();
      form.chapter = self.chapterList;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CourseApi.courseEdit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              localStorage.setItem('activeName','second')
              self.$router.push('/plus/course/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回文章列表*/
    cancelFunc() {
      localStorage.setItem('activeName','second')
      this.$router.push({
        path: '/plus/course/index'
      });
    },
    /*获取富文本框内容*/
    getContent: function() {
      //return this.$refs.ue.getUEContent();
    },

    /*获取富文本内容*/
    contentChangeFunc(e){
      this.form.course_content=e;
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.diy-container {
    display: flex;
  }
  .diy-phone {
    width: 375px;
    margin: 0 30px;
    border: 1px solid #CCCCCC;
    border-radius: 10px;
    overflow: hidden;
  }
.diy-phone-container {
  position: relative;
  height: calc(100vh - 350px);
}
.diy-phone-container .wrapper {
  height:100%;
  overflow-y: auto;
}
.diy-phone-container .diy-phone-item > div {
  position: relative;
  border: 2px solid #f1f1f2;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/course/course/edit.vue